import { jsx as _jsx } from "react/jsx-runtime";
export const Chip = ({ label, primaryColor, textColor, outlined, size, ...props }) => {
    function sizeSwitch(size) {
        switch (size) {
            case 'small':
                return 'px-3 py-.5 ml-1 text-xs';
            case 'medium':
                return 'px-3 py-1.5 ml-3 text-sm';
            default:
                return 'px-3 py-1.5 ml-3 text-sm';
        }
    }
    return (_jsx("span", { className: `inline-block min-w-[4rem] rounded-full
          text-${textColor || 'white'}
          ${outlined ? '' : `bg-${primaryColor}`}
          ${sizeSwitch(size || 'medium')} 
          ${outlined ? 'border-2' : ''} 
          border-${primaryColor}
        `, ...props, children: label }));
};
//# sourceMappingURL=Chip.js.map